import apiHandler from "../core/apiHandler";

const economicActivityApi = apiHandler('economic-activities');
export default economicActivityApi;
